export default __webpack_public_path__ + "static/media/background-auth.fc9db212.jpeg";